// components
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';
import { HorizontalCard } from '@/pwa/atoms/HorizontalCard/HorizontalCard';

// mui
import { LinearProgress, Stack, Typography } from '@mui/material';

const Progress = ({ progress }: { progress: number }) => {
  return (
    <Stack
      direction='row'
      spacing={2}
      sx={{
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <LinearProgress
        variant='determinate'
        value={progress}
        sx={{ flexGrow: 1 }}
      />
      <Typography variant='caption'>{progress}%</Typography>
    </Stack>
  );
};

export interface ActionsCategoryItem {
  id: string;
  title: string;
  subtitle: string;
  imageSrc?: string;
  isComplete: boolean;
  onClick: () => void;
}

export interface ActionsCategoryProps {
  title: string;
  description: string;
  progress: number;
  items: ActionsCategoryItem[];
  onBack: () => void;
}

/**
 * ActionsCategory is the category detail page showing item cards with progress.
 */
export const ActionsCategory = ({
  title,
  description,
  progress,
  items,
  onBack,
}: ActionsCategoryProps) => {
  return (
    <ModalPageTemplate onBack={onBack}>
      <PageTemplate
        maxWidth='sm'
        headerSlot={<PageHeader title={title} description={description} />}
        contentSlot={
          <Stack spacing={2}>
            <Progress progress={progress} />
            {items.map((item) => (
              <HorizontalCard
                key={item.id}
                title={item.title}
                subtitle={item.subtitle}
                imageSrc={item.imageSrc}
                onClick={item.onClick}
                slot={null}
              />
            ))}
          </Stack>
        }
      />
    </ModalPageTemplate>
  );
};

ActionsCategory.displayName = 'ActionsCategory';

export default ActionsCategory;
